var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c(
      "h3",
      { staticClass: "title", attrs: { content: "edit", placement: "bottom" } },
      [
        _vm._v("\n    Admin User Management\n    "),
        _c(
          "el-button",
          {
            staticStyle: { width: "180px" },
            attrs: { type: "primary" },
            on: {
              click: function($event) {
                return _vm.handleAdd()
              }
            }
          },
          [_vm._v("Create")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "search-toggle",
            on: {
              click: function($event) {
                _vm.searchExpanded = !_vm.searchExpanded
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.searchExpanded ? "Hide Filters" : "Show Filters") +
                "\n      "
            ),
            _c("em", {
              staticClass: "el-icon-arrow-up",
              class: { "is-collapsed": !_vm.searchExpanded }
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.searchExpanded,
            expression: "searchExpanded"
          }
        ],
        staticClass: "searchBox"
      },
      [
        _c(
          "el-form",
          {
            ref: "formInline",
            staticClass: "demo-form-inline",
            attrs: { model: _vm.formInline }
          },
          [
            _c(
              "div",
              { staticClass: "search-grid" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "lastName" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "Last Name", maxlength: "50" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submitSearch.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.formInline.lastName,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "lastName", $$v)
                        },
                        expression: "formInline.lastName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "firstName" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "First Name", maxlength: "50" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submitSearch.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.formInline.firstName,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "firstName", $$v)
                        },
                        expression: "formInline.firstName"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "search-toolbar" }, [
          _c(
            "div",
            { staticClass: "search-toolbar__actions" },
            [
              _c(
                "el-button",
                {
                  staticClass: "search",
                  attrs: { type: "primary" },
                  on: { click: _vm.submitSearch }
                },
                [_vm._v("Search")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "reset",
                  on: {
                    click: function($event) {
                      return _vm.resetForm("formInline")
                    }
                  }
                },
                [_vm._v("Reset")]
              )
            ],
            1
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "client-panel" },
      [
        _c("div", { staticClass: "client-panel__toolbar" }, [
          _c(
            "div",
            { staticClass: "search-toolbar__extra" },
            [
              _c("columns-control", {
                attrs: {
                  columns: _vm.columnsConfig,
                  "storage-key": "cms.adminUserManagement.columns"
                },
                on: { change: _vm.onColumnsChange }
              }),
              _vm._v(" "),
              _c(
                "el-dropdown",
                { ref: "filter", attrs: { trigger: "click" } },
                [
                  _c("span", { staticClass: "el-dropdown-link sortbox" }, [
                    _c("em", { staticClass: "filter" }),
                    _vm._v("\n          Filter\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "formFilter",
                          staticStyle: { width: "300px", padding: "14px 24px" },
                          attrs: { model: _vm.formFilter }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: {
                                label: "Sales Office",
                                prop: "salesOffice"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  on: { change: _vm.changeSalesOffice },
                                  model: {
                                    value: _vm.formFilter.salesOffice,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFilter,
                                        "salesOffice",
                                        $$v
                                      )
                                    },
                                    expression: "formFilter.salesOffice"
                                  }
                                },
                                [
                                  _c("el-option", { attrs: { value: "All" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.salesOfficeList, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: { label: "Region", prop: "region" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formFilter.region,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formFilter, "region", $$v)
                                    },
                                    expression: "formFilter.region"
                                  }
                                },
                                [
                                  _c("el-option", { attrs: { value: "All" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.regionList, function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "filterButton" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: {
                                    "margin-right": "15px",
                                    "margin-bottom": "0"
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "reset",
                                      on: {
                                        click: function($event) {
                                          _vm.$refs.filter.hide()
                                          _vm.resetForm("formFilter")
                                        }
                                      }
                                    },
                                    [_vm._v("Reset")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { staticStyle: { "margin-bottom": "0" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "search",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function() {
                                          _vm.$refs.filter.hide()
                                          _vm.submitSearch()
                                        }
                                      }
                                    },
                                    [_vm._v("Apply")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click" },
                  on: { command: _vm.handleCommand }
                },
                [
                  _c("span", { staticClass: "el-dropdown-link sortbox" }, [
                    _c("em", { staticClass: "sort" }),
                    _vm._v("\n          Sort by\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "userId,desc" } },
                        [_vm._v("Admin ID (descending order)")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "userId,asc" } },
                        [_vm._v("Admin ID (ascending order)")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "el-table",
          { attrs: { data: _vm.tableData } },
          [
            _vm.isColumnVisible("userId")
              ? _c("el-table-column", {
                  attrs: { prop: "userId", label: "ID", width: "100" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("userLevel")
              ? _c("el-table-column", {
                  attrs: { label: "User Permission", width: "150" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$commonjs.cmsUserLevelMap(
                                  scope.row.userLevel
                                )
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2603140419
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("salesOffices")
              ? _c("el-table-column", {
                  attrs: { label: "Sales Office", width: "120" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  scope.row.salesOffices &&
                                    scope.row.salesOffices.join(", ")
                                ) +
                                "\n      "
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    278835516
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("regions")
              ? _c("el-table-column", {
                  attrs: { label: "Region" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  scope.row.regions &&
                                    scope.row.regions.join(", ")
                                ) +
                                "\n      "
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    437534620
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("fullName")
              ? _c("el-table-column", {
                  attrs: { label: "Full Name" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.lastName + ", " + scope.row.firstName
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2524488801
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("lastLoginAt")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "lastLoginAt",
                    label: "Last login",
                    formatter: _vm.$commonjs.tableFormatDateTime
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Operation", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "Edit",
                            placement: "top"
                          }
                        },
                        [
                          _c("em", {
                            staticClass: "edit",
                            staticStyle: { "margin-right": "10px" },
                            on: {
                              click: function($event) {
                                return _vm.handleEdit(scope.row)
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showSave
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: "More",
                                placement: "top"
                              }
                            },
                            [
                              _c(
                                "el-dropdown",
                                {
                                  attrs: { trigger: "click" },
                                  on: {
                                    command: function(command) {
                                      return _vm.handleMore(command, scope.row)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-link sortbox" },
                                    [_c("em", { staticClass: "more" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "deleteAccount" } },
                                        [_vm._v("Delete account")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "restPassword" } },
                                        [_vm._v("Reset password")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("app-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [5, 10, 20, 50],
            total: _vm.total,
            "page-size": _vm.currentSize
          },
          on: {
            "size-change": function(v) {
              _vm.currentSize = v
              _vm.currentPage = 1
              _vm.getList()
            },
            "current-change": function(v) {
              _vm.currentPage = v
              _vm.getList()
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fafcd14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fafcd14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cmsUser/User.vue
// module id = null
// module chunks = 